'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getRGB = getRGB;
exports.rgba = rgba;
exports.canReadText = canReadText;
exports.hexToTransparentRGBA = hexToTransparentRGBA;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _underscore = require('../utils/underscore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RGB_REGEX = /^rgb/i;

/**
 * Returns the RGB channel values for a given color
 * @param {string} color - A color in hex, rgb(), or rgba() format
 * @returns {object} An object of the form { r, g, b }
 */
function getRGB(color) {
  var r = void 0;
  var g = void 0;
  var b = void 0;

  try {
    if (RGB_REGEX.test(color)) {
      var match = color.match(/(\d+)\D+(\d+)\D+(\d+)/);
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
    } else {
      var hexColor = color.toLowerCase().replace(/^#/, '');
      if (hexColor.length === 3) hexColor = hexColor.replace(/([0-9a-f])/g, '$1$1');
      r = parseInt(hexColor.substring(0, 2), 16);
      g = parseInt(hexColor.substring(2, 4), 16);
      b = parseInt(hexColor.substring(4, 6), 16);
    }
    if ([r, g, b].some(_underscore.isNaN)) return {};
  } catch (err) {
    return {};
  }

  return { r: r, g: g, b: b };
}

/**
 * @param {string} color - A color in hex, rgb(), or rgba() format
 * @param {number} opacity - A number between 0 (transparent) and 1 (opaque)
 * @returns {string} A string of the form "rgba(255, 150, 51, 0.75)"
 */
function rgba(color) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _getRGB = getRGB(color),
      r = _getRGB.r,
      g = _getRGB.g,
      b = _getRGB.b;

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
}

// https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
function getLuminance(hex) {
  var _getRGB2 = getRGB(hex),
      rRaw = _getRGB2.r,
      gRaw = _getRGB2.g,
      bRaw = _getRGB2.b;

  var r = rRaw / 255.0;
  var rLuminance = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);

  var g = gRaw / 255.0;
  var gLuminance = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);

  var b = bRaw / 255.0;
  var bLuminance = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

  return 0.2126 * rLuminance + 0.7152 * gLuminance + 0.0722 * bLuminance;
}

// https://www.w3.org/TR/WCAG21/#dfn-contrast-ratio
function getTextContrastRatio() {
  for (var _len = arguments.length, colors = Array(_len), _key = 0; _key < _len; _key++) {
    colors[_key] = arguments[_key];
  }

  (0, _invariant2.default)(colors.length === 2, 'Expected to receive 2 colors (received ' + colors.length + ' instead)');

  var _colors$map$sort = colors.map(getLuminance).sort(function (a, b) {
    return b - a;
  }),
      _colors$map$sort2 = _slicedToArray(_colors$map$sort, 2),
      lighterColorLuminance = _colors$map$sort2[0],
      darkerColorLuminance = _colors$map$sort2[1];

  return (lighterColorLuminance + 0.05) / (darkerColorLuminance + 0.05);
}

// https://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-contrast.html
var AA_CONTRAST_THRESHOLD = '4.5';

function canReadText(backgroundColor, textColor) {
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AA_CONTRAST_THRESHOLD;

  return getTextContrastRatio(backgroundColor, textColor) >= threshold;
}

/**
 * Creates a transparent RGBA equivalent of a hex color.
 * http://stackoverflow.com/a/6672545
 */
function hexToTransparentRGBA(hexColor) {
  var _getRGB3 = getRGB(hexColor),
      r = _getRGB3.r,
      g = _getRGB3.g,
      b = _getRGB3.b;

  var minChannelValue = Math.min(r, g, b);
  var alpha = (255 - minChannelValue) / 255;
  if (alpha > 0) {
    var convertChannel = function convertChannel(v) {
      return Math.round((v - minChannelValue) / alpha);
    };
    r = convertChannel(r);
    g = convertChannel(g);
    b = convertChannel(b);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha.toPrecision(3) + ')';
  }
  return 'transparent';
}